module.exports = __webpack_public_path__ + "static/media/kayak_img.d7aa86a7.jpg";